import { useEffect, useState } from 'react';
import {
  FieldErrors,
  UseFormClearErrors,
  UseFormRegister,
  UseFormSetValue,
  UseFormTrigger,
} from 'react-hook-form';
import { BookingNumberProps } from '@msc-b2c/interfaces/interfaces';
import { CheckboxForm, InputText, Text } from '@msc-b2c/shared-components';
import { validateFormField } from '@msc-b2c/shared-utils';

import styles from './bookingnumbersection.module.scss';

export function BookingNumberSection({
  enabledBookingNumber,
  labelToggleBookingNumber = '',
  inputLabelBookingNumber = '',
  inputPlaceholderBookingNumber = '',
  validationRulesContainerBookingNumber,
  register,
  errors,
  clearErrors,
  trigger,
  setValue,
}: Readonly<BookingNumberProps> & {
  register: UseFormRegister<any>;
  errors: FieldErrors;
  clearErrors: UseFormClearErrors<any>;
  trigger: UseFormTrigger<any>;
  setValue: UseFormSetValue<any>;
}) {
  const [isBookingNumberFieldEnabled, setIsBookingNumberFieldEnabled] =
    useState(enabledBookingNumber);

  useEffect(() => {
    if (!isBookingNumberFieldEnabled) {
      setValue('booking.number', '');
    }
  }, [isBookingNumberFieldEnabled]);

  return (
    <div className={styles['cmp-register__booking-number-section']}>
      <div className={styles['cmp-register__booking-number-toggle']}>
        <Text
          text={labelToggleBookingNumber}
          styleOption="cmp-text__normal"
        />
        <CheckboxForm
          index={1}
          name={'bookingNumberToggle'}
          onChange={() => setIsBookingNumberFieldEnabled((prev) => !prev)}
          register={register}
          errors={errors}
          clearErrors={clearErrors}
          checked={isBookingNumberFieldEnabled}
          styleOptions="cmp-form-options--toggle"
        />
      </div>
      {isBookingNumberFieldEnabled && (
        <InputText
          index={2}
          name={'booking.number'}
          label={inputLabelBookingNumber}
          placeholder={inputPlaceholderBookingNumber}
          register={register}
          errors={errors}
          clearErrors={clearErrors}
          validation={{
            validate: (value) => {
              return validateFormField(value, validationRulesContainerBookingNumber || []);
            },
            onBlur: () => trigger('booking.number'),
          }}
        />
      )}
    </div>
  );
}
